import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { variables } from '..';

export function SuccessIcon() {
  return (
    <FontAwesomeIcon
      icon={faCheck}
      size="1x"
      fixedWidth
      style={{ color: variables.brandSuccess }}
    />
  );
}
